import axios from "axios";
import {
  Autocomplete,
  Button,
  Checkbox,
  FloppyDiskIcon,
  Pane,
  Text,
  TextInputField,
} from "evergreen-ui";
import { PhoneIcon } from "evergreen-ui";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { FaGears } from "react-icons/fa6";

function CheckVutDoctory() {
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Basic " + localStorage.getItem("token"),
  };
  const [DataVutMaster, setDataVutMaster] = useState([]);
  const [DataVutDocter, setDataVutDocter] = useState([]);
  const fetchLEvelMaster = async () => {
    try {
      axios
        .post(
          "https://mua.kpru.ac.th/FrontEnd_Admission/admission/plan/",
          { level: "5" },
          { headers: headers }
        )
        .then((res) => {
          console.log(res.data);
          const loopdata = res.data;
          setDataVutMaster(loopdata);
          setGPA(localStorage.getItem("vga"));
          if (localStorage.getItem("plan") !== "") {
            const index = loopdata.findIndex(
              (item) => item.value === localStorage.getItem("plan")
            );
            setGrade(localStorage.getItem("plan"));
            setSelectedItem(index);
          } else {
          }
        });
      axios
        .post(
          "https://mua.kpru.ac.th/FrontEnd_Admission/admission/plan/",
          { level: "6" },
          { headers: headers }
        )
        .then((res) => {
          console.log(res.data);
          const loopdata = res.data;
          setDataVutDocter(loopdata);
          setGPA2(localStorage.getItem("vga2"));
          if (localStorage.getItem("plan2") !== "") {
            const index = loopdata.findIndex(
              (item) => item.value === localStorage.getItem("plan2")
            );
            setGrade2(localStorage.getItem("plan2"));
            setSelectedItem2(index);
          } else {
          }
        });
    } catch (error) {}
  };
  const fetVut = async () => {
    try {
      const fetch = await axios.get(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showcheckvut",
        { headers }
      );
      const dataVut = fetch.data.data.data;
      const data = fetch.data.data.data[0];
      if (dataVut.length !== 0) {
        const count = dataVut.length;
        for (let i = 0; i < count; i++) {
          if (dataVut[i].LEVEL_EDU_ID >= 5) {
            if (i === 1) {
              localStorage.setItem("level", dataVut[i].LEVEL_EDU_ID);
              localStorage.setItem("plan", dataVut[i].PLAN_ID);
              localStorage.setItem("vga", dataVut[i].LEVEL_MEMBER_VGA);
            } else {
              localStorage.setItem("level" + i, dataVut[i].LEVEL_EDU_ID);
              localStorage.setItem("plan" + i, dataVut[i].PLAN_ID);
              localStorage.setItem("vga" + i, dataVut[i].LEVEL_MEMBER_VGA);
            }

            console.log(dataVut[i]);
          }
        }
        // if (data.LEVEL_EDU_ID >= 5) {
        //   localStorage.setItem("level", data.LEVEL_EDU_ID);
        //   localStorage.setItem("plan", data.PLAN_ID);
        //   localStorage.setItem("vga", data.LEVEL_MEMBER_VGA);
        // } else {
        //   localStorage.setItem("level", "5");
        //   localStorage.setItem("plan", "");
        //   localStorage.setItem("vga", "");
        // }
        setChkFetch(true);
      }
    } catch (error) {}
  };
  const [Grade, setGrade] = useState("");
  const [GPA, setGPA] = useState("");
  const [Vutmn, setVutmn] = useState("");
  const [Grade2, setGrade2] = useState("");
  const [GPA2, setGPA2] = useState("");
  const [VutKru2, setVutKru2] = useState("");
  const [ChkFetch, setChkFetch] = useState(false);
  useEffect(() => {
    fetchLEvelMaster();
    fetVut();
  }, []);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItem2, setSelectedItem2] = useState(null);
  const [Kru, setKru] = useState(null);
  useEffect(() => {}, [ChkFetch]);
  return (
    <>
      <Pane className="container p-2">
        <Pane
          className="bg-white p-2 px-3 d-flex flex-wrap"
          borderRadius={8}
          boxShadow="0px 0px 10px #00000030"
        >
          <div
            className="col-12 pb-3"
            style={{ fontSize: "22px", fontWeight: "500" }}
          >
            วุฒิการศึกษา &nbsp;{" "}
            <Text className="text-danger">* หากไม่พบข้อมูล โทร. 055-706547</Text>
          </div>
          <div className="col-12 pb-1" style={{ fontSize: "16px" }}>
            -- ระดับปริญญาตรี
          </div>
          <div className="col-md-8">
            <Autocomplete
              items={DataVutMaster}
              selectedItem={DataVutMaster[selectedItem]}
              itemToString={(item) => (item ? item.label : "")}
              // defaultHighlightedIndex={DataVutMaster[5]}
              onChange={(changedItem) => {
                localStorage.setItem("level", "5");
                localStorage.setItem("plan", changedItem.value);
                setGrade(changedItem.value);
              }}
            >
              {({
                key,
                getInputProps,
                getToggleButtonProps,
                getRef,
                inputValue,
                openMenu,
                toggleMenu,
              }) => (
                <Pane
                  width="100%"
                  ref={getRef}
                  display="flex "
                  alignItems="center"
                  gap={10}
                >
                  <TextInputField
                    width="100%"
                    key={key}
                    placeholder="เลือกวุฒิการศึกษา"
                    value={inputValue}
                    onFocus={openMenu}
                    {...getInputProps()}
                    label="เลือกสาขา"
                    name="major"
                  />
                  <Button
                    iconBefore={<FaGears />}
                    appearance="primary"
                    onClick={toggleMenu}
                    {...getToggleButtonProps()}
                  >
                    เปิดตัวเลือก
                  </Button>
                </Pane>
              )}
            </Autocomplete>
          </div>
          <div className="col-md-4">
            <TextInputField
              label="ผลการเรียน"
              value={GPA}
              name="gpa"
              onChange={(e) => {
                localStorage.setItem("vga", e.target.value);
                setGPA(e.target.value);
              }}
              maxLength={4}
            />
          </div>
          <div className="col-12 pb-1" style={{ fontSize: "16px" }}>
            -- ระดับปริญญาโท
          </div>
          <div className="col-md-8">
            <Autocomplete
              items={DataVutDocter}
              selectedItem={DataVutDocter[selectedItem2]}
              itemToString={(item) => (item ? item.label : "")}
              // defaultHighlightedIndex={DataVutMaster[5]}
              onChange={(changedItem) => {
                localStorage.setItem("level2", "6");
                localStorage.setItem("plan2", changedItem.value);
                setGrade2(changedItem.value);
              }}
            >
              {({
                key,
                getInputProps,
                getToggleButtonProps,
                getRef,
                inputValue,
                openMenu,
                toggleMenu,
              }) => (
                <Pane
                  width="100%"
                  ref={getRef}
                  display="flex "
                  alignItems="center"
                  gap={10}
                >
                  <TextInputField
                    width="100%"
                    key={key}
                    placeholder="เลือกวุฒิการศึกษา"
                    value={inputValue}
                    onFocus={openMenu}
                    {...getInputProps()}
                    label={
                      <div>
                        เลือกสาขา ({" "}
                        <Text className="text-primary" >
                          หากไม่มีสาขาที่ต้องการ สามารถติดต่อได้ที่ <PhoneIcon/> (055) 706 547
                        </Text>
                         {" "})
                      </div>
                    }
                    name="major"
                  />
                  <Button
                    iconBefore={<FaGears />}
                    appearance="primary"
                    onClick={toggleMenu}
                    {...getToggleButtonProps()}
                  >
                    เปิดตัวเลือก
                  </Button>
                </Pane>
              )}
            </Autocomplete>
          </div>
          <div className="col-md-4">
            <TextInputField
              label="ผลการเรียน"
              value={GPA2}
              name="gpa"
              onChange={(e) => {
                localStorage.setItem("vga2", e.target.value);
                setGPA2(e.target.value);
              }}
              maxLength={4}
            />
          </div>
          <div className="col-8">
            <Checkbox
              checked={Kru === true}
              onChange={() => {
                setKru(true);
                setVutmn("have");
              }}
              label="มีใบประกาศนียบัตรบัณฑิต (การบริหารการศึกษา)"
            />
            <Checkbox
              checked={Kru === false}
              onChange={() => {
                setKru(false);
                setVutmn("not");
              }}
              label="ไม่มีใบประกาศนียบัตรบัณฑิต (การบริหารการศึกษา)"
            />
          </div>
          <div className="col-12 d-flex flex-row justify-content-end">
            <Button
              iconBefore={<FloppyDiskIcon />}
              appearance="primary"
              intent="success"
              disabled={
                GPA === "" || Grade === "" || Kru === null ? true : false
              }
              onClick={() => {
                // localStorage.setItem("vga2", "");
                // localStorage.setItem("plan2", "");
                // localStorage.setItem("level2", "");
                if (Vutmn === "have") {
                  localStorage.setItem("vga3", "0.00");
                  localStorage.setItem("plan3", "603");
                  localStorage.setItem("level3", "13");
                } else {
                  localStorage.setItem("vga3", "");
                  localStorage.setItem("plan3", "");
                  localStorage.setItem("level3", "");
                }
                window.location.pathname = "admission/Formregister-master";
              }}
            >
              บันทึก
            </Button>
          </div>
        </Pane>
      </Pane>
    </>
  );
}

export default CheckVutDoctory;
